(function () {
  "use strict";

  var module = angular.module("uwAgenda.users");
  module.factory("UserService", [
    "$http",
    "$rootScope",
    "$uibModalStack",
    "$uibModal",
    "$localStorage",
    "SearchService",
    'ExternalPatientBroadcast',
    "ContactInfoService",
    "$translate",
    "UserContactInfoTypeEnum",
    UserServiceFn,
  ]);

  /* main user service */
  function UserServiceFn(
      $http, 
      $rootScope, 
      $uibModalStack, 
      $uibModal,
      $localStorage,
      SearchService,
      ExternalPatientBroadcast,
      ContactInfoService,
      $translate,
      UserContactInfoTypeEnum
      ) {
    var baseUrl = "/api/users/";
    var service = {
      query: query,
      subusers: subusers,
      get: get,
      save: save,
      update: update,
      updateActiveStateById: updateActiveStateById,
      getAgendas: getAgendas,
      updateUserTermsAndConditions: updateUserTermsAndConditions,
      getMainUserIds: getMainUserIds,
      address: address,
      additionalinfos: additionalinfos,
      singleOnlineBookingLink: singleOnlineBookingLink,
      groupOnlineBookingLink: groupOnlineBookingLink,
      showSpecificPatientWarning: showSpecificPatientWarning,
      updateWarning: updateWarning,
      show: show,
      showWarningOfPatients: showWarningOfPatients,
      signature: signature,
      showDeactivateUserById: showDeactivateUserById,
      showDeactivateMainUserById: showDeactivateMainUserById,
      deactivateAgendaByOwnerId: deactivateAgendaByOwnerId,
      quickSavePatient: quickSavePatient,
      contactInfosByUser: contactInfosByUser,
      block: block,
      showBlockUserModal: showBlockUserModal,
      getByUniqueId: getByUniqueId,
      getExternalPatientSearchResult : getExternalPatientSearchResult,
      getExternalPatientCaption: getExternalPatientCaption,
      setExternalPatientIncomingData: setExternalPatientIncomingData,
      refreshExternalPatientSearchResult: refreshExternalPatientSearchResult,
      clearExternalPatient: clearExternalPatient,
      preSelectExternalPatient: preSelectExternalPatient,
      getPhoneNumberForCommunication: getPhoneNumberForCommunication,
      getAgendaOwnerToDeactivateInfoById: getAgendaOwnerToDeactivateInfoById,
      getIntegrationOwnerToCleanupContactsInfoById: getIntegrationOwnerToCleanupContactsInfoById,
      showCleanupContactsById: showCleanupContactsById,
      cleanupContactsOfIntegrationOwnerById: cleanupContactsOfIntegrationOwnerById,
      showPatientIsBlockedWarning: showPatientIsBlockedWarning,
      setCorilusPersonId: setCorilusPersonId,
      removeCorilusPersonId: removeCorilusPersonId,
      getUsersWithCorilusPassport: getUsersWithCorilusPassport
    };

    return service;
    
    function setCorilusPersonId(userId, corilusPassportToken) {
      return $http.put(baseUrl + `${userId}/coriluspersonid`, { corilusPassportToken: corilusPassportToken })
          .then(response => response.data);
    }
    
    function removeCorilusPersonId(userId) {
      return $http.delete(baseUrl + `${userId}/coriluspersonid`)
        .then(response => response.data);
    }
    
    function getUsersWithCorilusPassport(corilusPasswordToken) {
      return $http({
        url: baseUrl + `coriluspersonid`,
        method: "GET",
        headers: {
        'Authorization': `Bearer ${corilusPasswordToken}`
      }}).then(response => response.data);
    }

    /* get all items */
    function query(userId, agendaId, filter) {
      return $http({
        url: baseUrl + userId + "/subusers/agendas/" + agendaId + "/active/" + !!filter.active + "/blocked/" + !!filter.blocked + "/deleted/" + !!filter.deleted,
        method: "GET",
      }).then(function (response) {
        return response.data;
      });
    }

    /* get by Unique id */
    function getByUniqueId(userId, uniqueId) {
      return $http({
        url: baseUrl + userId + "/patients/" + uniqueId,
        method: "GET",
      }).then(function (response) {
        return response.data;
      });
    }

    /* get all subusers */
    function subusers(userId, agendaId, active, blocked, deleted, filter, syncedOnly, activelySynced, nonSyncedOnly) {
      return $http({
        url: baseUrl + userId + "/subusers/agendas/" + agendaId + "/active/" + active + "/blocked/" + blocked + "/deleted/" + deleted,
        method: "GET",
        params: {
          pageSize: filter.itemsPerPage,
          pageNumber: filter.currentPage,
          includeCount: filter.includeCount,
          searchFilter: filter.searchFilter,
          roles: filter.roles,
          sharedAgendaOwnerIds: filter.sharedAgendaOwnerIds,
          syncedOnly: syncedOnly,
          activelySynced: activelySynced,
          nonSyncedOnly: nonSyncedOnly
        },
      }).then(function (response) {
        return response.data;
      });
    }

    /* get by id */
    function get(userId, clientId, agendaId, selectAgenda) {
      return $http({
        url: baseUrl + userId + "/clients/" + clientId + "/agendas/" + agendaId,
        method: "GET",
        params: {
          selectAgenda: selectAgenda ? selectAgenda : false,
        },
      }).then(function (response) {
        return response.data;
      });
    }

    /* contact-infos by user */
    function contactInfosByUser(id) {
      return $http
        .get(baseUrl + id + "/contactinfos")
        .then(function (response) {
          return response.data;
        });
    }

    /* get user additional info */
    function additionalinfos(id, agendaId) {
      return $http
        .get(baseUrl + id + "/additionalinfos/agendas/" + agendaId)
        .then(function (response) {
          return response.data;
        });
    }

    /* get address of user */
    function address(id, agendaId) {
      return $http
        .get(baseUrl + id + "/address/agendas/" + agendaId)
        .then(function (response) {
          return response.data;
        });
    }

    /* quick save patient */
    function quickSavePatient(agendaId, patient) {
      return $http
        .post(baseUrl + "agendas/" + agendaId + "/quick", patient)
        .then(function (response) {
          return response.data;
        });
    }

    /* save item */
    function save(mainUserId, agendaId, item) {
      return $http
        .post(baseUrl + mainUserId + "/agendas/" + agendaId, item)
        .then(function (response) {
          return response.data;
        });
    }

    /* update item */
    function update(userId, clientId, agendaId, item) {
      return $http
        .put(
          baseUrl + userId + "/clients/" + clientId + "/agendas/" + agendaId,
          item
        )
        .then(function (response) {
          return response.data;
        });
    }

    function updateActiveStateById(userId, agendaId, active) {
      return $http
          .put(baseUrl + userId + "/agendas/" + agendaId + "/active/" + active)
          .then(function (response) {
            return response.data;
          });
    }

    function deactivateAgendaByOwnerId(agendaOwnerId, moveContactsToAgendaId) {
      return $http
          .put(baseUrl + agendaOwnerId + "/agenda/deactivate?moveToAgendaId=" + moveContactsToAgendaId)
          .then(function (response) {
            return response.data;
          });
    }
    
    function block(userId, agendaId) {
      return $http
        .patch(baseUrl + userId + "/block/agendas/" + agendaId)
        .then(function (response) {
          return response.data;
        });
    }

    /* update terms and conditions for user */
    function updateUserTermsAndConditions(userId, termsAndConditionsPatchCommand) {
      return $http
          .patch(baseUrl + userId + "/termsandconditions", termsAndConditionsPatchCommand)
          .then(function (response) {
            return response.data;
          });
    }

    /* get shared agendas for user */
    function getAgendas(userId) {
      return $http({
        url: baseUrl + userId + "/agendas",
        method: "GET",
        params: {
          protocols: $rootScope.isRingfoon,
        },
      }).then(function (response) {
        return response.data;
      });
    }

    /* get main user ids for a subuser */
    function getMainUserIds(userId, agendaId) {
      return $http
        .get(baseUrl + userId + "/parent/agendas/" + agendaId)
        .then(function (response) {
          return response.data;
        });
    }

    /* online booking link */
    function singleOnlineBookingLink(userId, agendaId) {
      return $http
        .get(baseUrl + userId + "/singleonlinebookinglink/agendas/" + agendaId)
        .then(function (response) {
          return response.data;
        });
    }

    /* group practice online booking link */
    function groupOnlineBookingLink(userId, agendaId) {
      return $http
        .get(baseUrl + userId + "/grouponlinebookinglink/agendas/" + agendaId)
        .then(function (response) {
          return response.data;
        });
    }

    /* update warning */
    function updateWarning(id, agendaId, warning) {
      return $http
        .put(baseUrl + id + "/warning/agendas/" + agendaId, '"' + warning + '"')
        .then(function (response) {
          return response.data;
        });
    }

    /* get warning of User */
    function getUserWarning(id, agendaId) {
      return $http
        .get(baseUrl + id + "/warning/agendas/" + agendaId)
        .then(function (response) {
          if (response && response.data && response.data.length > 0) {
            return response.data;
          } // if
          else {
            return null;
          }
        });
    }

    // show warning of patients by user
    function showWarningOfPatients(id, number, agendaId) {
      getWarningOfPatients(id, agendaId , number).then(function (result) {
        show(result);
      });
    }

    /* get warning of Patients by User */
    function getWarningOfPatients(id, agendaId, number) {
      return $http({
        url: '/api/users/' + id + "/warning/patients/agendas/" + agendaId,
        method: "GET",
        params: {
          number: number,
        },
      }).then(function (response) {
        return response.data;
      });
    }

    /**
     * Get the phone number used in communication for a user.
     * @param userId {number} Id of user
     * @return {PromiseLike<string>}
     */
    function getPhoneNumberForCommunication(userId) {
      return $http
          .get(`${baseUrl}${userId}/phoneNumberForCommunication`)
          .then(response => response.data);
    }


    // show warning of patients by user
    function showSpecificPatientWarning(patientCaption, warningInfo) {
      if (warningInfo)
      {
        return showWarningPopup([{ caption: patientCaption, warningInfo: warningInfo }]);
      }
      
      return Promise.resolve();
    }
    
    function showPatientIsBlockedWarning(patient) {
      if (patient && patient.isBlockedInMyOrganizer) {
        return showSpecificPatientWarning(
            $translate.instant('user_blocked_in_myorganizer'),
            $translate.instant('user_blocked_in_myorganizer_info'));
      }
      
      return Promise.resolve();
    }

    // show the warning
    function showWarningPopup(users) {
      // warning to show ?

      let found = false;
      if (users) {
        let i = 0;
        const len = users.length;
        for (i; i < len; i++) {
          if (users[i].warningInfo) {
            found = true;
            break;
          }
        }
      }
      if (!found) { return Promise.resolve(); }

      // open modal
      return $uibModal.open({
        backdrop: 'static',
        keyboard: false,
        animation: true,
        templateUrl: '/app/ringfoon/templates/warning-modal.template.html',
        controller: 'WarningModalController',
        controllerAs: 'vm',
        size: 'md',
        resolve: {
          users: function () {
            return users;
          }
        }
      }).result;
    }
    
    /* get signature of user */
    function signature(id, agendaId) {
      return $http
        .get(baseUrl + id + "/signature/agendas/" + agendaId)
        .then(function (response) {
          return response.data;
        });
    }

    // Show User-Information
    function show(id, clientId, agendaId) {
      // close other modals
      $uibModalStack.dismissAll();

      // open new modal
      return $uibModal.open({
        backdrop: true,
        keyboard: true,
        windowClass: "modal-to-right quick-sidebar-modal",
        openedClass: "quick-sidebar-modal-body",
        animation: true,
        controller: "UserShowInfoModalController",
        controllerAs: "vm",
        templateUrl: "/app/users/templates/user-show-info-modal.template.html",
        size: "lg",
        resolve: {
          user: get(id, clientId, agendaId),
        },
      });
    }

    // show the modal to deactivate item
    function showDeactivateUserById(id, agendaId) {
      // open modal
      var modalInstance = $uibModal.open({
        backdrop: "static",
        keyboard: false,
        animation: true,
        templateUrl:
          "/app/users/templates/user-deactivating-modal.template.html",
        controller: "UserDeactivatingController",
        controllerAs: "viewModel",
        size: "md",
        resolve: {
          userId: id
        }
      });

      // when modal is closed
      return modalInstance.result.then(
        function () {
          return updateActiveStateById(id, agendaId, false);
        },
        function () {
          // dismissed
          return;
        }
      );
    }

    function showDeactivateMainUserById(id) {
      return getAgendaOwnerToDeactivateInfoById(id)
          .then((agendaStatus) => {
            let modalResult = { selectedAgenda: 0 };
            if (agendaStatus.sharedAgendaUsers.length > 0 && agendaStatus.subUserCount > 0) {
              return $uibModal.open({
                backdrop: "static",
                keyboard: false,
                animation: true,
                templateUrl: "/app/users/templates/mainuser-deactivating-modal.template.html",
                controller: "MainUserDeactivatingController",
                controllerAs: "viewModel",
                size: "md",
                resolve: {
                  agendaStatus: agendaStatus,
                  result: modalResult
                }
              })
                .result
                .then(() => {
                  return $uibModal.open({
                    backdrop: "static",
                    keyboard: false,
                    animation: true,
                    templateUrl: "/app/users/templates/mainuser-deactivating-confirmation-modal.template.html",
                    controller: "MainUserDeactivatingConfirmationController",
                    controllerAs: "viewModel",
                    size: "md",
                    resolve: {
                      agendaStatus: agendaStatus,
                      input: modalResult
                    }
                  })
                    .result
                    .then(() => {
                      return deactivateAgendaByOwnerId(id, modalResult.selectedAgenda);
                    }, () => {});
                }, () => {})
            } else {
              return $uibModal.open({
                backdrop: "static",
                keyboard: false,
                animation: true,
                templateUrl: "/app/users/templates/mainuser-deactivating-confirmation-modal.template.html",
                controller: "MainUserDeactivatingConfirmationController",
                controllerAs: "viewModel",
                size: "md",
                resolve: {
                  agendaStatus: agendaStatus,
                  input: modalResult
                }
              })
                  .result
                  .then(() => {
                    return deactivateAgendaByOwnerId(id, modalResult.selectedAgenda);
                  }, () => {});
            }
          });
    }

    function showCleanupContactsById(id) {
      return getIntegrationOwnerToCleanupContactsInfoById(id)
        .then((info) => {
          let modalResult = {
            deactivateNonSynced: false,
            mergeDoppelgangers: false
          };
          return $uibModal.open({
            backdrop: "static",
            keyboard: false,
            animation: true,
            templateUrl: "/app/users/templates/contact-cleanup-modal.template.html",
            controller: "ContactCleanupController",
            controllerAs: "viewModel",
            size: "md",
            resolve: {
              info: info,
              modalResult: modalResult
            }
          })
            .result
            .then(() => {
              return cleanupContactsOfIntegrationOwnerById(
                  id,
                  modalResult.deactivateNonSynced,
                  modalResult.mergeDoppelgangers);
            }, () => {
            })
        });
    }
    
    function getAgendaOwnerToDeactivateInfoById(id) {
      return $http
          .get(baseUrl + id + "/deactivate/info")
          .then(function (response) {
            return response.data;
          });
    }

    function getIntegrationOwnerToCleanupContactsInfoById(id) {
      return $http
        .get(baseUrl + id + "/merge/emr/info")
        .then(function (response) {
          return response.data;
        });
    }

    function cleanupContactsOfIntegrationOwnerById(id, deactivateNonSynced, mergeDoppelgangers) {
      return $http
          .post(baseUrl + id + "/merge/emr", {
            deactivateNonSynced,
            mergeDoppelgangers,
          })
          .then(function (response) {
            return response.data;
          });
    }
    
    function showBlockUserModal(id, agendaId, userName) {
      // open modal
      var modalInstance = $uibModal.open({
        backdrop: "static",
        keyboard: false,
        animation: true,
        templateUrl: "/app/users/templates/block-user-modal.html",
        controller: "BlockUserModalController",
        controllerAs: "vm",
        size: "xs",
        resolve: {
          userName: function () {
            return userName;
          },
        },
      });

      var modalResult = modalInstance.result;

      // when modal is closed
      modalResult.then(
        function () {
          return block(id, agendaId);
        },
        function () {
          // dismissed          
        }
      );

      return modalResult;
    }

    function showExternalPatientSelectionModal(phoneNumber) {
      return $uibModal.open({
        backdrop: 'static',
        keyboard: false,
        animation: true,
        templateUrl: '/app/agenda/templates/agenda-appointment-external-patient-selection-modal.template.html',
        controller: 'AgendaAppointmentExternalPatientSelectionModalController',
        controllerAs: 'vm',
        size: 'md',
        resolve: {
          phoneNumber: function() {
            return phoneNumber;
          }
        }

      }).result;
    }

    function getExternalPatientSearchResult(agendaOwnerUserId) {
      if (!$localStorage.ExternalPatientIncomingData) {
        return Promise.resolve(null);
      }

      // check if PatientResult is loaded
      if ($localStorage.ExternalPatientSearchResult) {
        return Promise.resolve($localStorage.ExternalPatientSearchResult);
      }

      // check if userid is known
      if ($localStorage.ExternalPatientIncomingData.userId) {
        // load external patient result in local storage
        return getByUniqueId(agendaOwnerUserId, $localStorage.ExternalPatientIncomingData.userId)
          .then(patient => {
            if (patient) {

              if (patient.detail) {
                showSpecificPatientWarning(patient.caption, patient.detail.warningInfo);
              }
              showPatientIsBlockedWarning(patient);
              
              $localStorage.ExternalPatientSearchResult = [patient];
              $rootScope.$broadcast(ExternalPatientBroadcast.set);
            }
            
            return $localStorage.ExternalPatientSearchResult;
          });
      } 
      
      if ($localStorage.ExternalPatientIncomingData.phone) {
        // search for patients via phonenumber
        return SearchService.searchPatients(
          agendaOwnerUserId,
            $localStorage.ExternalPatientIncomingData.phone,
            $localStorage.ExternalPatientIncomingData.birthday)
          .then(selectOneOfMultipleFoundPatients);
      }
      
      if ($localStorage.ExternalPatientIncomingData.lastName) {
        let userQuery = `${$localStorage.ExternalPatientIncomingData.firstName} ${$localStorage.ExternalPatientIncomingData.lastName}`;
        return SearchService.searchPatients(
          agendaOwnerUserId,
            userQuery,
            $localStorage.ExternalPatientIncomingData.birthday)
          .then(selectOneOfMultipleFoundPatients);
      }
      
      return Promise.resolve(null);

      function selectOneOfMultipleFoundPatients(patients) {
        patients = filterEyefileUsersFromExternalData(patients);
        $localStorage.ExternalPatientSearchResult = patients;
        if (patients.length > 1) {
          return showExternalPatientSelectionModal($localStorage.ExternalPatientIncomingData.phone)
            .then(_ => {
              const patient = $localStorage.ExternalPatientSearchResult[0];

              if (patient.detail) {
                showSpecificPatientWarning(patient.caption, patient.detail.warningInfo);
              }
              showPatientIsBlockedWarning(patient);

              return $localStorage.ExternalPatientSearchResult;
            });
        } else if (patients.length === 1) {
        
          const patient = $localStorage.ExternalPatientSearchResult[0];
          $rootScope.$broadcast(ExternalPatientBroadcast.set);

          if (patient.detail) {
            showSpecificPatientWarning(patient.caption, patient.detail.warningInfo);
          }
          showPatientIsBlockedWarning(patient);
        } else {
          $rootScope.$broadcast(ExternalPatientBroadcast.set);
        }
        return $localStorage.ExternalPatientSearchResult;
      }
    }

    function getExternalPatientCaption(externalPatientResult, checkPhoneRecognition = false) {
      let caption = '';
      if(checkPhoneRecognition){
        if (externalPatientResult && externalPatientResult.length === 1)
        {
          // get patient
          let externalPatient = externalPatientResult[0];
          caption = `${externalPatient.firstName} ${externalPatient.lastName}`;
        }else{
          // no or too many results so just show sent data
          if ($localStorage.ExternalPatientIncomingData && $localStorage.ExternalPatientIncomingData.lastName)
          {
            caption = `${$localStorage.ExternalPatientIncomingData.firstName} ${$localStorage.ExternalPatientIncomingData.lastName}`;
          }
        }
      }
      if ($localStorage.ExternalPatientIncomingData && $localStorage.ExternalPatientIncomingData.phone){
        caption = `${caption} ${$localStorage.ExternalPatientIncomingData.phone}`.trim();
      }
      return caption;
    }

    function setExternalPatientIncomingData(agendaId, userId, firstName, lastName, phone, eyeFileUserId, birthday, isKnown) {
      $localStorage.ExternalPatientIncomingData = {agendaId, userId, firstName, lastName, phone, eyeFileUserId, birthday, isKnown };
    }

    function clearExternalPatient() {
      
      delete $localStorage.ExternalPatientSearchResult;
      delete $localStorage.ExternalPatientIncomingData;

      $rootScope.$broadcast(ExternalPatientBroadcast.clear);
    }

    function refreshExternalPatientSearchResult(patient) {
      if (patient)
      {
        $localStorage.ExternalPatientSearchResult = [patient];
        $rootScope.$broadcast(ExternalPatientBroadcast.set);

      }else{
        // no specific patient was set so try to research
          delete $localStorage.ExternalPatientSearchResult;
          $rootScope.$broadcast(ExternalPatientBroadcast.set);
      }
      
    }
    
    // Fill in phonenumber in the patient contactDetails (if the field is present in contactinfos)
    function setPatientMobileOrPhoneNumber(patientOrAppointment, mobileNumber) {
      if (mobileNumber && patientOrAppointment.patient &&
          patientOrAppointment.patient.contactInfos) {
        let contactInfoType = UserContactInfoTypeEnum.Phone.value;
        if (mobileNumber.startsWith("000324") || mobileNumber.startsWith("00324") || mobileNumber.startsWith("324") ||
          mobileNumber.startsWith("04") || mobileNumber.startsWith("4")) {
          contactInfoType = UserContactInfoTypeEnum.Mobile.value;
        }

        let contactInfoMobile =  patientOrAppointment.patient.contactInfos.filter(function(ci) {
          return ci.fK_UserContactInfoType === contactInfoType;
        })[0];
        if (contactInfoMobile) {
          contactInfoMobile.value = mobileNumber;
        }else{
          let info = ContactInfoService.createContactInfoByTypeValue(contactInfoType);
          info.value = mobileNumber;
          patientOrAppointment.patient.contactInfos.push(info);
        }
      }
    }

    function setPatientFromExternalDataAndLoadContactInfos(newPatient, taskOrAppointment, agendaId) {

      // look up patient's contact infos & assign to appointment's patient
      // assign EyeFileUserId to the found patient
      if ($localStorage.ExternalPatientIncomingData.eyeFileUserId) {
        newPatient.eyeFileUserId = $localStorage.ExternalPatientIncomingData.eyeFileUserId;
      }

      // fill in birthday, if the found patient has no birthday yet
      if ($localStorage.ExternalPatientIncomingData.birthday && !newPatient.birthday) {
        newPatient.birthday = $localStorage.ExternalPatientIncomingData.birthday;
      }
      if (newPatient.id && 
        (!newPatient.contactInfos || 
          newPatient.contactInfos.length === 0 ||
          !newPatient.contactInfos[0].userContactInfoType)) {
        contactInfosByUser(newPatient.id)
          .then(function (contactInfos) {
            newPatient.contactInfos = contactInfos;
            taskOrAppointment.patient = newPatient;
          });
      } else {
        taskOrAppointment.patient = newPatient;
      }
    }    
    function filterEyefileUsersFromExternalData(patients){
      // filter patients if eyeFileUserId is set 
      if ($localStorage.ExternalPatientIncomingData.eyeFileUserId) {
        let patientMatchedByEyeFileUserId = patients.filter(function(patient) {
          return patient.eyeFileUserId === parseInt($localStorage.ExternalPatientIncomingData.eyeFileUserId, 10);
        })[0];

        if (patientMatchedByEyeFileUserId) {
          patients = [patientMatchedByEyeFileUserId];
        }
      }
      return patients;
    }

    function processExternalPatientDialogResult(selectionResult, taskOrAppointment, agendaId) {
      let externalPatientFromIncomingData = $localStorage.ExternalPatientIncomingData;
      if (!selectionResult.selectedPatient) {
        if (selectionResult.autoFillPatientName === true) {
          // fill in patient's firstName, lastName, birthday & eyeFileUserId
          let newPatient = Object.assign({},taskOrAppointment.patient);
          if (externalPatientFromIncomingData) {
            newPatient.firstName = externalPatientFromIncomingData.firstName;
            newPatient.lastName = externalPatientFromIncomingData.lastName;
            newPatient.birthday = externalPatientFromIncomingData.birthday;
            newPatient.eyeFileUserId = externalPatientFromIncomingData.eyeFileUserId;
            setPatientMobileOrPhoneNumber(taskOrAppointment,externalPatientFromIncomingData.phone);
          }
          taskOrAppointment.unknownPatient = !externalPatientFromIncomingData.isKnown;
          taskOrAppointment.patient = newPatient;
        }
      } else {
        setPatientFromExternalDataAndLoadContactInfos(selectionResult.selectedPatient, taskOrAppointment, agendaId);
      }
      return taskOrAppointment;
    }

    function preSelectExternalPatient(appointmentOrTask, agendaOwnerId, agendaId) {
      return getExternalPatientSearchResult(agendaOwnerId)
        .then(patients => {
          if (!patients || patients.length === 0) {
            if ($localStorage.ExternalPatientIncomingData) {
              let selectedPatient = {autoFillPatientName: true};
              processExternalPatientDialogResult(selectedPatient, appointmentOrTask, agendaId);
            }
            return;
          }

          setPatientFromExternalDataAndLoadContactInfos(patients[0], appointmentOrTask, agendaId);
          return appointmentOrTask;
        });
    }
  }
})();
